import { FORM_ACTIONS } from './formValidation'
import { get } from '@bigyouth/base'
import axios from 'axios'
import { get as getPipe } from '../utils/sigpipe'
import emitter from '../utils/emitter'
import translate from '../utils/translations'

import { bpOk as triggerBpOk, bpEventOk as triggerBpEventOk } from './fbTrigger'

export default {
  name: 'send-datas',

  currentStep: 1,
  brochureWindow: null,

  ui: {
    errorWrap: '[js-send-datas-error-wrap]',
    submitButton: '[js-send-datas-submit]',
    'changeStep[]': '[js-send-datas-change-step]',
    'progress[]': '[js-send-datas-progress]',
  },

  componentDidMount() {
    if (this.props.isDealers) {
      const searchParams = new URLSearchParams(window.location.search)
      const model = searchParams.get('model')

      if (model) {
        this.el.querySelector('[js-port-model]').customSelect.value = model
      }
    }

    const formId = this.el.getAttribute('data-form-id')
    this.pipe = getPipe(formId)
    this.pipe.on((message) => {
      const action = message.action
      switch (action) {
        case 'nextStepOk':
          this.currentStep++
          this.changeStep('plus')

          break

        case FORM_ACTIONS.ERROR:
          if (this.props.isNewsletter) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ 'event': 'newsletter-nok' })
          }

          break

        case FORM_ACTIONS.SUBMIT:
          const formDataNew = new FormData()

          for (const [key, value] of Object.entries(message.formData)) {
            formDataNew.append(key, value)
          }

          const urlParams = new URLSearchParams(window.location.search)
          for (const paramName of urlParams.keys()) {
            if (paramName.startsWith('utm_')) {
              formDataNew.append(paramName, urlParams.get(paramName))
            }
          }

          formDataNew.append('action', this.props.action)
          formDataNew.append('nonce', this.props.nonce)

          if (get('[js-send-datas-error]', this.el)) {
            get('[js-send-datas-error]', this.el).remove()
          }

          if (this.props.urlBrochure) {
            this.brochureWindow = window.open('', '_blank')
          }

          /* eslint-disable-next-line */
          const loader = document.createElement('div')
          loader.classList.add('loader')
          this.ui.submitButton.prepend(loader)
          this.ui.submitButton.classList.add('is-loading')

          this.manageTracking(true)

          this.sendDatas(formDataNew)
      }
    })

    // can't be put in events because steps are not always here
    if (this.ui.changeStep.length > 0) {
      this.ui.progress[0].style.transform = `scaleX(${(this.currentStep) / parseInt(this.props.totalStep)})`

      this.ui.changeStep.forEach(button => {
        button.addEventListener('click', (e) => {
          if (e.target.dataset.type === 'minus') {
            this.currentStep--
            this.changeStep('minus')
          } else {
            this.pipe.write({ action: 'validateStep', step: e.target.closest('.form-page__panel') })
          }
        })
      })
    }

    if (this.props.initStep > 1) {
      this.currentStep = this.props.initStep
      this.changeStep('plus')
    }
  },

  changeStep(type) {
    this.manageTracking()
    get('[js-send-datas-step].is-active').classList.remove('is-active')

    let nextStep = this.currentStep
    const portStatesSelect = get(`[js-send-datas-step][data-step="${this.currentStep}"]`).querySelector('[js-port-states]')
    if (portStatesSelect) {
      const portStatesOptions = portStatesSelect.querySelectorAll('option')
      if (portStatesOptions && portStatesOptions.length === 1) {
        if (type === 'plus') {
          nextStep++
        } else {
          nextStep--
        }
      }
    }

    let stepElem = get(`[js-send-datas-step][data-step="${nextStep}"]`)
    stepElem.classList.add('is-active')
    let stepTitle = stepElem.querySelector("h2")
    if (stepTitle) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      window.scrollTo({
        top: stepTitle.getBoundingClientRect().top + scrollTop,
        left: 0,
        behavior: 'smooth'
      })
    }

    this.ui.progress.forEach(progress => {
      progress.style.transform = `scaleX(${(nextStep) / parseInt(this.props.totalStep)})`
    })
  },

  manageSuccess(response) {
    if (this.props.urlBrochure) {
      this.brochureWindow.location.href = this.props.urlBrochure
      triggerBpOk()
      setTimeout(function () {
        history.go(-1)
        setTimeout(function () { document.querySelector('[js-back-website]').click() })
      }, 500)
    } else if (this.brochureWindow != null) {
      this.brochureWindow.close()
    }

    if (this.props.urlSuccess) {
      if (this.isEvent()) {
        triggerBpEventOk()
      } else {
        triggerBpOk()
      }

      let _this = this
      window.setTimeout(function () {
        if (_this.props.isLanding) {
          const model = _this.el.querySelector('[js-port-model]')
          window.location.href = `${_this.props.urlSuccess}&model=${model.options[model.selectedIndex].dataset.id}`
        } else if (_this.props.isConfig3d) {
          const encodedUrl = encodeURIComponent(response.data.data.link)
          window.location.href = `${_this.props.urlSuccess}&link=${encodedUrl}`
        } else {
          window.location.href = _this.props.urlSuccess
        }
      }, 500)
    } else {
      if (this.props.comparator) {
        emitter.trigger('comparatorEnd', {
          content: response.data.data,
        })
      } else if (this.props.isSalon) {
        const success = document.createElement('p')
        success.innerHTML = translate('FORM_SUCCESS_SALON')
        this.el.parentNode.append(success)
        this.el.parentNode.querySelector('.button-reload').classList.remove('is-hidden')
        this.el.remove()
        document.body.scrollTo(0, 0)
      } else if (this.props.isNewsletter) {
        const success = document.createElement('p')
        success.innerHTML = translate('FORM_SUCCESS_NEWSLETTER')
        this.el.parentNode.append(success)
        this.el.remove()
      } else if (this.props.isContact) {
        const success = document.createElement('p')
        success.innerHTML = translate('FORM_SUCCESS_CONTACT_INFO')
        this.el.parentNode.append(success)
        this.el.remove()
      }
    }
  },

  manageError(response) {
    if (response) {
      console.error(response.data)

      get('.loader', this.el).remove()
      this.ui.submitButton.classList.remove('is-loading')

      const error = document.createElement('div')
      error.classList.add('form__error', 'mb-6', 'text-right', 'form-page__padded-content')
      error.setAttribute('js-send-datas-error', '')
      error.innerHTML = response.data.message !== undefined ? response.data.message : translate('FORM_ERROR_SENDING')
      this.ui.errorWrap.prepend(error)

      if (response.data.invalid_fields) {
        const theForm = this.ui.submitButton.form
        response.data.invalid_fields.forEach((item) => {
          if (item.field && item.message) {
            let theElement = theForm.querySelector("#" + item.field)
            if (theElement) {
              const error = document.createElement('p')
              error.classList.add('form__error')
              error.innerHTML = item.message
              theElement.parentElement.insertAdjacentElement('afterend', error)
            }
          }
        })
      }
    }
  },

  isEvent() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })

    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
    return params.event
  },

  manageTracking(lastStep = false) {
    window.dataLayer = window.dataLayer || []
    let isEvent = this.isEvent()
    if (lastStep) {
      if (this.props.isNewsletter) {
        window.dataLayer.push({ 'event': 'newsletter-ok' })
        window.dataLayer.push({ 'event': 'newsletter-envoyé' })
      } else if (this.props.isSeaTrial) {
        let trackingPath = 'essai'
        window.dataLayer.push({ 'event': trackingPath + '-4-merci' })
        window.dataLayer.push({ 'event': 'BP envoyé' })
      } else if (this.props.isDealers) {
        let trackingPath = 'concessionnaire'
        window.dataLayer.push({ 'event': trackingPath + '-4-question' })
        window.dataLayer.push({ 'event': trackingPath + '-5-merci' })
        window.dataLayer.push({ 'event': 'BP envoyé' })
      } else if (this.props.action == 'form_job') {
        let trackingPath = this.props.nonce ? 'offre' : 'candidature'
        window.dataLayer.push({ 'event': trackingPath + '-3-informations' })
        window.dataLayer.push({ 'event': trackingPath + '-4-merci' })
        window.dataLayer.push({ 'event': 'candidature - envoyée' })
      } if (this.props.urlBrochure) {
        let trackingPath = 'brochure'
        window.dataLayer.push({ 'event': trackingPath + '-3-question' })
        window.dataLayer.push({ 'event': 'BP envoyé' })
      } else if (this.props.typeLanding == 'private-event') {
        let trackingPath = 'evenement-prive'
        window.dataLayer.push({ 'event': trackingPath + '-3-question' })
        window.dataLayer.push({ 'event': trackingPath + '-4-merci' })
        window.dataLayer.push({ 'event': 'bp_envent_envoyé' })
      } else if (isEvent) {
        let trackingPath = "evenement"
        window.dataLayer.push({ 'event': trackingPath + '-3-question' })
        window.dataLayer.push({ 'event': trackingPath + '-4-merci' })
        window.dataLayer.push({ 'event': 'bp_envent_envoyé' })
      } else if (this.props.isConfig3d) {
        let trackingPath = "configurateur"
        window.dataLayer.push({ 'event': trackingPath + '-5-envoyé' })
        window.dataLayer.push({ 'event': 'BP envoyé' })
      } else if (this.props.action == 'wp_fp_zoho_boarding_pass__send_boarding_pass_ajax') {
        let trackingPath = "essai"
        window.dataLayer.push({ 'event': trackingPath + '-3-question' })
        window.dataLayer.push({ 'event': trackingPath + '-4-merci' })
        window.dataLayer.push({ 'event': 'BP envoyé' })
      }
    } else {
      let nextStep = this.currentStep
      if (this.props.urlBrochure) {
        let trackingPath = 'brochure'
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-1-coordonnees' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-2-port' })
        }
      } else if (this.props.typeLanding == 'private-event') {
        let trackingPath = 'evenement-prive'
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-1-coordonnees' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-2-port' })
        }
      } else if (isEvent) {
        let trackingPath = "evenement"
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-1-coordonnees' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-2-port' })
        }
      } else if (this.props.isDealer) {
        let trackingPath = "concessionnaire"
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-1-modele' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-2-coordonnees' })
        } else if (nextStep == 4) {
          window.dataLayer.push({ 'event': trackingPath + '-3-port' })
        }
      } else if (this.props.action == "form_job") {
        let trackingPath = this.props.nonce ? "offre" : "candidature"
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-1-agence' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-2-coordonnees' })
        }
        /*
         else if (nextStep==4){
          window.dataLayer.push({'event': 'offre-3-informations'})
        } else if (nextStep==5){
          window.dataLayer.push({'event': 'offre-4-merci'})
          window.dataLayer.push({'event': 'candidature - envoyée'})          
        }*/
      } else if (this.props.isConfig3d) {
        let trackingPath = "configurateur"
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-3-coordonnees' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-4-port' })
        }
      } else if (this.props.action == 'wp_fp_zoho_boarding_pass__send_boarding_pass_ajax') {
        let trackingPath = "essai"
        if (nextStep == 2) {
          window.dataLayer.push({ 'event': trackingPath + '-1-coordonnees' })
        } else if (nextStep == 3) {
          window.dataLayer.push({ 'event': trackingPath + '-2-port' })
        }
        /* else if (nextStep == 4) {
          window.dataLayer.push({ 'event': trackingPath + '-3-question' })
        }*/
      }
    }
  },

  sendDatas(formData) {
    axios.post(this.props.url, formData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => {
        if (response.data.success || response.data.status === 'mail_sent') {
          get('.loader', this.el).remove()
          this.ui.submitButton.classList.remove('is-loading')

          // IF BP, send another request
          if (this.props.action === 'wp_fp_zoho_boarding_pass__send_dealers_boarding_pass_ajax' || this.props.action === 'wp_fp_zoho_boarding_pass__send_boarding_pass_ajax') {
            const newFormData = new FormData()
            newFormData.append('action', this.props.action === 'wp_fp_zoho_boarding_pass__send_dealers_boarding_pass_ajax' ? 'wp_fp_zoho_boarding_pass__send_dealers_boarding_pass_to_sap' : 'wp_fp_zoho_boarding_pass__send_boarding_pass_to_sap')
            newFormData.append('nonce', response.data.nonce)
            newFormData.append('data', response.data.data)

            axios.post(this.props.url, newFormData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(response2 => {
                // do nothing
              })
              .catch(e => {
                console.error(e)
              })
          }

          this.manageSuccess(response)
        } else {
          this.manageError(response)
        }
      })
      .catch(e => {
        if (e.response) {
          get('.loader', this.el).remove()
          this.ui.submitButton.classList.remove('is-loading')

          const error = document.createElement('div')
          error.classList.add('form__error', 'mb-6', 'text-right', 'form-page__padded-content')
          error.setAttribute('js-send-datas-error', '')
          error.innerHTML = e.response.data.message !== undefined ? e.response.data.message : translate('FORM_ERROR_SENDING')

          this.ui.errorWrap.prepend(error)
        }
      })
  },
}
